<template>
  <div>
    <v-toolbar color="white" class="elevation-0">
      <v-btn icon @click="hideFilters">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Filtros</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat @click="reset">Limpar</v-btn>
        <v-btn flat @click="apply">Aplicar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    
    <v-container grid-list-md>
      <v-layout row wrap>
        <!-- Data Inicial -->
        <v-flex xs12 sm6 md3>
          <v-menu
            ref="menuStartAt"
            :close-on-content-click="false"
            v-model="menuStartAt"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="startAtFormatted"
              label="Data Inicial"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="startAt"
              @input="menuStartAt = false"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <!-- Data Final -->
        <v-flex xs12 sm6 md3>
          <v-menu
            ref="menuEndAt"
            :close-on-content-click="false"
            v-model="menuEndAt"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="endAtFormatted"
              label="Data Final"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="endAt"
              @input="menuEndAt = false"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <!-- Status -->
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="status"
            :items="statusOptions"
            label="Status"
            clearable
          ></v-select>
        </v-flex>

        <!-- Motivo -->
        <v-flex xs12 sm6 md3>
          <v-text-field
            v-model="reason"
            label="Motivo"
            clearable
          ></v-text-field>
        </v-flex>

        <!-- Valor -->
        <v-flex xs12 sm6 md3>
          <v-text-field
            v-model="amount"
            label="Valor"
            type="number"
            clearable
          ></v-text-field>
        </v-flex>

        <!-- Ordenação -->
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="ordination"
            :items="ordinationOptions"
            label="Ordenação"
            clearable
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'ChargebacksFilters',
  data() {
    return {
      startAt: moment().startOf('month').format('YYYY-MM-DD'),
      endAt: moment().endOf('month').format('YYYY-MM-DD'),
      startAtFormatted: moment().startOf('month').format('DD/MM/YYYY'),
      endAtFormatted: moment().endOf('month').format('DD/MM/YYYY'),
      menuStartAt: false,
      menuEndAt: false,
      status: '',
      reason: '',
      amount: '',
      ordination: '',
      statusOptions: [
        { text: 'Pendente', value: 'pending' },
        { text: 'Aprovado', value: 'approved' },
        { text: 'Rejeitado', value: 'rejected' }
      ],
      ordinationOptions: [
        { text: 'Data (mais recente)', value: 'date_desc' },
        { text: 'Data (mais antiga)', value: 'date_asc' },
        { text: 'Valor (maior)', value: 'amount_desc' },
        { text: 'Valor (menor)', value: 'amount_asc' },
        { text: 'ID (maior)', value: 'id_desc' },
        { text: 'ID (menor)', value: 'id_asc' }
      ]
    };
  },
  computed: {
    ...mapGetters({
      filters: 'chargebacks/chargebacksFilter',
      showFilters: 'chargebacks/showFilters'
    })
  },
  watch: {
    startAt(val) {
      this.startAtFormatted = moment(val).format('DD/MM/YYYY');
      this.$store.dispatch('chargebacks/setInitialDate', this.formatDate(val, 'start'));
    },
    endAt(val) {
      this.endAtFormatted = moment(val).format('DD/MM/YYYY');
      this.$store.dispatch('chargebacks/setFinalDate', this.formatDate(val, 'end'));
    },
    status(val) {
      this.$store.dispatch('chargebacks/setStatus', val);
    },
    reason(val) {
      this.$store.dispatch('chargebacks/setReason', val);
    },
    amount(val) {
      this.$store.dispatch('chargebacks/setAmount', val);
    },
    ordination(val) {
      this.$store.dispatch('chargebacks/setOrdination', val);
    }
  },
  methods: {
    ...mapActions({
      loadList: 'chargebacks/loadList',
      resetFilters: 'chargebacks/resetFilters',
      showFiltersAction: 'chargebacks/showFilters'
    }),
    
    hideFilters() {
      this.showFiltersAction(false);
    },
    
    apply() {
      const params = {
        page: 1,
        limit: 25,
        filterrific: {
          with_created_at_between: {
            start_at: this.formatDate(this.startAt, 'start'),
            end_at: this.formatDate(this.endAt, 'end')
          },
          with_status: this.status,
          with_reason: this.reason,
          with_amount: this.amount,
          sorted_by: this.ordination
        }
      };
      
      this.loadList(params);
      this.hideFilters();
    },
    
    reset() {
      this.startAt = moment().startOf('month').format('YYYY-MM-DD');
      this.endAt = moment().endOf('month').format('YYYY-MM-DD');
      this.status = '';
      this.reason = '';
      this.amount = '';
      this.ordination = '';
      
      this.resetFilters();
      this.hideFilters();
    },
    
    formatDate(date, kind) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      if (kind === 'start') {
        return `${year}-${month}-${day} 00:00:00`;
      } else {
        return `${year}-${month}-${day} 23:59:59`;
      }
    }
  }
};
</script> 